import api from "./api";

/*
 * The signed-in user's inbox of platform-admin notifications, and their push
 * device tokens. Every call is scoped to the caller by the API.
 */

/** GET /business/me/notifications — { notifications, meta: { unread, current_page, last_page, … } } */
export const fetchNotifications = async ({ page = 1, perPage = 10 } = {}) => {
  const { data } = await api.get("/business/me/notifications", {
    params: { page, per_page: perPage },
  });
  return { notifications: data.data.notifications, meta: data.meta };
};

/** GET /business/me/notifications/unread-count */
export const fetchUnreadCount = async () => {
  const { data } = await api.get("/business/me/notifications/unread-count");
  return data.data.unread;
};

/** POST /business/me/notifications/{id}/read — returns the recomputed unread count. */
export const markNotificationRead = async (id) => {
  const { data } = await api.post(`/business/me/notifications/${id}/read`);
  return data.data.unread;
};

/** POST /business/me/notifications/read-all */
export const markAllNotificationsRead = async () => {
  const { data } = await api.post("/business/me/notifications/read-all");
  return data.data.unread;
};

/** POST /business/device-tokens — register or refresh this browser's FCM token. */
export const registerDeviceToken = (token, locale) =>
  api.post("/business/device-tokens", { token, platform: "web", locale });

/** DELETE /business/device-tokens/{token} */
export const unregisterDeviceToken = (token) =>
  api.delete(`/business/device-tokens/${encodeURIComponent(token)}`);
